import React, { useState } from 'react';
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { globals } from '../../misc/globals';
import { getOptionBorder, mapDivEnterToClick, setFocus } from '../../misc/tools';
import { ScoreType } from '../../scenarios/CalmBaseScenario';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';
import './KnowledgeCheckUI.css'

const KnowledgeCheckUI = (props: UIProperties<KnowledgeCheckUIConfig>) => {
	const [forceUpdate, setForceUpdate] = useState(false);
	
	return (
		<div style={{
			pointerEvents: 'all'
		}} className="pls-fade">
			<div style={{
				width: '1100px',
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)'
			}} tabIndex={0} id='knowledge-check-first' aria-label={'Knowledge Check'}>
				<img style={{
				}} src="./assets/images/general/components/knowledge-check/bg.png" alt="" />
				<p style={{
					margin: '0',
					position: 'absolute',
					top: '2px',
					left: '0px',
					width: '100%',
					fontSize: '18pt',
					textAlign: 'center'
				}} className="title-font">Knowledge Check</p>

				<p style={{
					margin: '0',
					position: 'absolute',
					top: '52px',
					left: '0px',
					width: '100%',
					fontSize: '16pt',
					textAlign: 'center'
				}} className="regular-description-font" tabIndex={0}>{props.parameters.title}</p>

				<div style={{
					    position: 'absolute',
						top: '100px',
						left: '50%',
						width: '982px',
						height: '467px',
						overflow: 'auto',
						transform: 'translate(-50%, 0)'
				}}>
					{props.parameters.questions.map((q: KnowledgeCheckQuestion, qIndx: number) => {
						return (
							<div key={Tools.generateGuid()} style={{
								position: 'relative'
							}}>
								<img style={{
								}} src="./assets/images/general/components/knowledge-check/q_bg.png" alt="" />
								<p className="regular-description-font" style={{
									position: 'absolute',
									top: '11px',
									left: '14px',
									margin: '0',
									width: '920px',
								}}>{(qIndx + 1) + '.'}</p>

								<p className="regular-description-font" style={{
									position: 'absolute',
									top: '11px',
									left: '40px',
									margin: '0',
									width: '920px'
								}} tabIndex={0}>{q.title}</p>

								<div style={{
									position: 'absolute',
									top: '61px',
									left: '27px',
									width: '50%',
									display: 'grid',
    								gridTemplateColumns: 'auto auto'
								}}>
									{q.choices.map((c: KnowledgeCheckChoices, cIndx: number) => {
										var id = 'choice' + qIndx + cIndx;
										return(
											<div style={{
												width: '100%',
												position: 'relative',
												border: globals.showDebugForComponents && globals.showDebugAnswerTypes && c.isCorrect ? getOptionBorder(ScoreType.Best) : ''
											}} id={id} className="pointer" tabIndex={0} aria-label={c.title} 
											onKeyUp={mapDivEnterToClick} onClick={() => {
												var clickAudio = document.getElementById('button-click');
												
												if(!globals.isMuted) {
													(clickAudio as any).play();
												}
												props.parameters.questions[qIndx].choices[cIndx].isSelected = !props.parameters.questions[qIndx].choices[cIndx].isSelected;
												setForceUpdate(!forceUpdate);
												setFocus(id);
											}}>
												<img style={{}} src={'./assets/images/general/components/knowledge-check/button_knowledgecheck_' + (c.isSelected ? 'down' : 'main') +'.png'}/>
												<p className="regular-description-font" style={{
													position: 'absolute',
													top: '4px',
													left: '50px',
													margin: '0',
													width: '180px'
												}}>{c.title}</p>
											</div>
										);
									})}
								</div>
							</div>
						);
					})}
				</div>

				<GeneralButtonWithText parameters= {{
					text: 'Submit',
					id:"knowledge-check-last",
					top: '558px',
					left: '444px',
					width: '413.33px',
					onClicked: () => {
						var correctQuestions = 0;
						for(var qIndx = 0; qIndx < props.parameters.questions.length; qIndx++) {
							var question = props.parameters.questions[qIndx];
							var selectedChoices = question.choices.filter(c => c.isSelected);
							var correctSelectedChoices = question.choices.filter(c => c.isCorrect && c.isSelected);
							var correctChoices = question.choices.filter(c => c.isCorrect);

							if(selectedChoices.length === correctSelectedChoices.length && correctSelectedChoices.length === correctChoices.length) {
								correctQuestions++;
							}
						}

						props.parameters.score = correctQuestions * 100;
						props.parameters.onSubmit(props.parameters);
					}
				}}/>
			</div>
			
		</div>
	);

};

export interface KnowledgeCheckUIConfig extends BaseConfig {
	title: string;
	score: number;
	questions: KnowledgeCheckQuestion[];
	onSubmit: (config?: KnowledgeCheckUIConfig) => void;
}

export interface KnowledgeCheckQuestion {
	title: string;
	choices: KnowledgeCheckChoices[];
}

export interface KnowledgeCheckChoices {
	title: string;
	isCorrect: boolean;
	isSelected?: boolean;
}

export default KnowledgeCheckUI;